export default __webpack_public_path__ + "static/TSD_Report_Graphic-6c7cce515075deebd30514a9346da999.png";